const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

(() => {
  'use strict';

  const SECTION_SELECTOR = '.home_featured_product';
  const SELECT_SELECTOR = '.select__select';
  const LINK_SELECTOR =
    'a.product-form__submit.button.view_meal_plan';

  const PRODUCT_URLS = {
    '5': '/products/subscription-5-meal-pack',
    '10': '/products/subscription-10-meal-pack',
    '15': '/products/15-meal-pack-subscription',
    '20': '/products/20-meal-pack-subscription'
  };

  /**
   * Get the meal number from the dropdown.
   * Supports values such as "15" or text such as "15 Meals".
   */
  function getMealCount(select) {
    if (!select) return '';

    const rawValue = String(
      select.value ||
      select.selectedOptions?.[0]?.textContent ||
      ''
    ).trim();

    const numberMatch = rawValue.match(/\d+/);

    return numberMatch ? numberMatch[0] : rawValue;
  }

  /**
   * Find the dropdown related to a button or section.
   */
  function getSelect(element) {
    const section = element?.closest(SECTION_SELECTOR);

    return (
      section?.querySelector(SELECT_SELECTOR) ||
      document.querySelector(
        `${SECTION_SELECTOR} ${SELECT_SELECTOR}`
      )
    );
  }

  /**
   * Update all relevant URL attributes.
   */
  function updateLink(link, productUrl) {
    if (!link || !productUrl) return;

    link.setAttribute('href', productUrl);

    // Some themes/apps navigate using data attributes
    if (link.hasAttribute('data-href')) {
      link.setAttribute('data-href', productUrl);
    }

    if (link.hasAttribute('data-url')) {
      link.setAttribute('data-url', productUrl);
    }

    link.dataset.mealPlanUrl = productUrl;
  }

  /**
   * Update the buttons inside one featured-product section.
   */
  function updateSection(section) {
    if (!section) return;

    const select = section.querySelector(SELECT_SELECTOR);
    const mealCount = getMealCount(select);
    const productUrl = PRODUCT_URLS[mealCount];

    if (!productUrl) return;

    section
      .querySelectorAll(LINK_SELECTOR)
      .forEach((link) => {
        updateLink(link, productUrl);
      });
  }

  /**
   * Initialize every featured-product section.
   */
  function initializeMealPlanLinks() {
    document
      .querySelectorAll(SECTION_SELECTOR)
      .forEach(updateSection);
  }

  /**
   * Update the button whenever the dropdown changes.
   */
  document.addEventListener(
    'change',
    (event) => {
      const select = event.target.closest(
        `${SECTION_SELECTOR} ${SELECT_SELECTOR}`
      );

      if (!select) return;

      const section = select.closest(SECTION_SELECTOR);
      updateSection(section);
    },
    true
  );

  /**
   * Intercept button clicks before another theme/app
   * handler can use the original 5-meal URL.
   */
  window.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest(LINK_SELECTOR);

      if (!link) return;

      const select = getSelect(link);
      const mealCount = getMealCount(select);
      const productUrl = PRODUCT_URLS[mealCount];

      if (!productUrl) return;

      updateLink(link, productUrl);

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      window.location.assign(productUrl);
    },
    true
  );

  /**
   * Initialize when the page loads.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeMealPlanLinks,
      { once: true }
    );
  } else {
    initializeMealPlanLinks();
  }

  /**
   * Reinitialize if Shopify or an app redraws the section.
   */
  let observerTimer;

  const observer = new MutationObserver(() => {
    clearTimeout(observerTimer);

    observerTimer = setTimeout(
      initializeMealPlanLinks,
      100
    );
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();